// owned by WP-DESK-HOST · English strings of the host-drawn desk header and desk loading states (SPEC §17).
// Key path `econic.desks.*`; deep-merged by ./index.en.ts with every other area (a duplicate leaf key throws in development).
const desksEn = {
  econic: {
    desks: {
      crumbs: "Where you are",
      workspaces: "Desks",
      deskNumbered: "{{n}} · {{name}}",
      switcher: {
        label: "Process desks",
        desk: "Desk {{n}} · {{name}}",
        deliverable: "Switch deliverable",
        groups: { waiting: "Waiting on you", underway: "Under way", new: "New", delivered: "Delivered" },
        current: "Open now",
      },
      drawsOn: "Draws on",
      drawsOnPrimary: "{{module}} · main source",
      drawsOnSecondary: "{{module}} · also used",
      moduleCount: "{{count}}",
      moduleDue: "action due",
      moduleState: { stale: "sources not up to date", awaiting: "awaiting data" },
      statusLabel: "Status",
      details: "Details",
      detailsFor: "Details · {{name}}",
      dates: "Dates",
      versionLabel: "Version",
      routinesLabel: "Routines",
      roles: { prepared: "Prepared", reviewed: "Reviewed", supervised: "Supervised", label: "Roles", none: "Not assigned", line: "{{role}} {{who}}" },
      due: "Due {{date}}",
      noDue: "No due date",
      version: "Version {{n}} · {{date}}",
      routines_one: "1 routine",
      routines_other: "{{count}} routines",
      routinesNext: "next {{when}}",
      stage: "Stage {{current}} of {{total}} · {{name}}",
      nextGate: "Next: {{gate}}",
      readiness: "Readiness {{done}} of {{total}}",
      readinessBlocked: "Release blocked",
      present: "Present",
      exportPdf: "Export PDF",
      generatePdf: "Generate PDF",
      readinessButton: "Readiness",
      moreFor: "More actions · {{name}}",
      askAbout: "Ask ECONIC",
      about: "About",
      aboutDesk: "About {{name}}",
      ask: "Ask",
      askPrompt: "About the {{name}} desk: ",
      askDeliverable: "About {{deliverable}} on the {{name}} desk: ",
      more: "More",
      context: "Current file",
      classification: "Marking",
      updated: {
        title: "An update is ready",
        reload: "Reload",
        later: "Later",
      },
      loading: {
        label: "Opening the desk",
        slow: "The first open takes a moment.",
      },
      error: {
        title: "This desk could not open",
        retry: "Retry",
        report: "Report an issue",
        reportPrompt: "The {{name}} desk did not open: {{error}}",
        about: "About this desk",
        pageTitle: "This page could not open",
        pageAbout: "About this page",
      },
      pageHeader: "Page",
    },
  },
};

export default desksEn;
